export default {
  API_ENDPOINT: 'https://michaelfeil.github.io/web-tfjs/api',
  // API_ENDPOINT: 'https://[YOUR-ROUTE].mybluemix.net/api'
};
